import { combineReducers } from 'redux';
import vmware from './vmware';

export default combineReducers({
  vmware,
});



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/redux/reducers/hosts/storage/index.js